export const getIsStaging = () =>
  window.location.host === 'devexceladdin.azureedge.net' ||
  window.location.host === 'preview.eyko.io' ||
  window.location.host === 'qaeykoexceladdin.blob.core.windows.net';
